import { useEffect, useState } from 'react';
import API from '../../../Infrastructure/API';

interface Settings {
  authToken?: string;
  enabled?: boolean;
}

export default function useMultiFactorAuthenticationList({ authToken, enabled = true }: Settings) {
  const [response, setResponse] = useState<Awaited<ReturnType<typeof API.multiFactorAuthentication.list>>>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!authToken || !enabled) {
      return;
    }

    setLoading(true);
    setError(false);

    API.multiFactorAuthentication
      .list(authToken)
      .then((response) => {
        setResponse(response);
        setFetched(true);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [authToken, enabled]);

  return {
    response,
    loading,
    error,
    fetched,
  };
}
